<template>
  <section id="thankYou">
    <div class="container">
      <div class="content">
        <h2>Thank You</h2>
        <p>Pencils For Kids, Inc. is blessed with bighearted friends who donate their talent, resources and insights to bring our vision to life. With gratitude, we acknowledge:</p>
        <div class="columns">
          <div v-for="thankYou in thankYous">
            <h5 v-html="thankYou.name"></h5>
            <p v-html="thankYou.organization"></p>
          </div>
        </div>
      </div>
      <div class="image">
        <img src="~assets/images/PFK_OurTeam_Photo4_ThankYou_260x260.jpg" class="img-fluid">
      </div>
    </div>
    <div class="scrim"></div>
  </section>
</template>

<script>
export default {
  name: 'thank-you',
  props: ['thankYous']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 7rem 0 6rem;
  background-color: lighten($gold, 15%);
}

.container {
  @include media('tablet') {
    display: flex;
  }
  @include media('desktop') {
    width: 900px;
  }
}

.content {
  flex: 1;
  margin-right: 5rem;
}

.columns {
  @include media('tablet') {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  margin-top: 3rem;
  > div {
    width: 48%;
    margin: 0.75rem 0;
  }
}

.image {
  padding-top: 1.5rem;
}

h2 {
  color: $brand-primary;
  margin-bottom: 1rem;
}

h5 {
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.45;
}
</style>



// WEBPACK FOOTER //
// ThankYou.vue?8c38a940